import type { RootState } from '@/store/store';

export const selectAnalyticsStatus = (state: RootState) => state.analytics.status;
export const selectAnalyticsData = (state: RootState) => state.analytics.data;
export const selectAnalyticsError = (state: RootState) => state.analytics.error;
export const selectAnalyticsTimeRange = (state: RootState) => state.analytics.timeRange;
export const selectAnalyticsCustomRange = (state: RootState) => state.analytics.customRange;
export const selectAnalyticsTraffic = (state: RootState) => state.analytics.traffic;
export const selectAnalyticsMetrics = (state: RootState) => state.analytics.metrics;
export const selectAnalyticsConversions = (state: RootState) => state.analytics.conversions;
